import { observable } from "mobx";

export type BaseSlipSelectionType = {
    masterEventId: string;
    eventId: string;
    type: string;
    lineId: string;
    leagueId: string;
    branchId: string;
    branchName: string;
    leagueName: string;
    eventTypeId: string;
    eventTypeName: string;
    oppositeEventTypeId: string;
    team1Name: string;
    team2Name: string;
    liveGroupId: number;
    preLiveGroupId: number;
    maxBet: number;
    minBet: number;
    waitingAllowed: boolean;
    singleSelectionRisk?: number;
    lineTypeName: string;
    odds: string | number;
}

export class BaseSlipSelection {

    masterEventId: string;
    eventId: string;
    lineId: string;
    type: string;
    leagueId: string;
    valid: boolean;
    final: boolean;
    @observable lastUpdate: Date;
    branchId: string;
    branchName: string;
    leagueName: string;
    eventTypeId: string;
    eventTypeName: string;
    oppositeEventTypeId: string;
    team1Name: string;
    team2Name: string;
    liveGroupId: number;
    preLiveGroupId: number;
    @observable maxBet: number;
    @observable minBet: number;
    waitingAllowed: boolean;
    singleSelectionRisk?: number;
    lineTypeName: string;
    initilized: boolean;
    // American odds
    @observable odds: string | number;

    constructor(source: BaseSlipSelectionType) {
        this.masterEventId = source.masterEventId;
        this.eventId = source.eventId;
        this.type = source.type;
        this.lineId = source.lineId;
        this.leagueId = source.leagueId;
        this.valid = true;
        this.final = true;
        this.lastUpdate = new Date();
        this.branchId = source.branchId;
        this.branchName = source.branchName;
        this.leagueName = source.leagueName;
        this.eventTypeId = source.eventTypeId;
        this.eventTypeName = source.eventTypeName;
        this.oppositeEventTypeId = source.oppositeEventTypeId;
        this.team1Name = source.team1Name;
        this.team2Name = source.team2Name;
        this.liveGroupId = source.liveGroupId;
        this.preLiveGroupId = source.preLiveGroupId;
        this.maxBet = source.maxBet;
        this.minBet = source.minBet;
        this.waitingAllowed = source.waitingAllowed;
        this.singleSelectionRisk = source.singleSelectionRisk;
        this.lineTypeName = source.lineTypeName;
        this.initilized = true;
        this.odds = source.odds;
    }
}